module.exports = __webpack_public_path__ + "img/slider-home-3@3x.5757e7a9.png";